// extracted by mini-css-extract-plugin
module.exports = {"text-gradient":"styles_text-gradient__3qyjH","text":"styles_text__19IKC"};